import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import _ from 'lodash';
import { DocumentType, PrimaryIDs, SecondaryIDs, } from '@/helpers/entities/interfaces/v2/forms/KycFormFields';
import Modal from '@/components/v3/Modal.vue';
let ToggleConfirmationDialog = class ToggleConfirmationDialog extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.modalOpen = false;
        this.fileUrl = '';
        this.confirmation = '';
        this.confirmErrors = [];
    }
    /**
     * event handler if component is confirmed
     */
    get setHeight() {
        return {
            height: `${this.height}px`,
        };
    }
    get setMobileHeight() {
        const mobile_height = parseInt(this.height, 10) + 50;
        return {
            height: `${mobile_height}px`,
        };
    }
    fileAttachment(kycDocument) {
        const fileUrl = kycDocument?.file?.blob?.originalUrl;
        const fileName = kycDocument?.file?.blob?.filename;
        fetch(fileUrl)
            .then((response) => response.blob())
            .then((blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        });
    }
    formatText(text) {
        if (text === DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT) {
            return 'SELFIE WITH SECONDARY IDs DOCUMENT';
        }
        return _.startCase(text);
    }
    get filteredKycDocuments() {
        const businessType = this.form.businessDetails.type;
        const requiredDocumentTypes = {
            SOLE_PROPRIETORSHIP: [
                DocumentType.SERVICE_AGREEMENT_DOCUMENT,
                DocumentType.SELFIE_WITH_PRIMARY_ID_DOCUMENT,
                DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT,
                DocumentType.DTI_REGISTRATION_DOCUMENT,
                DocumentType.BIR_2303_DOCUMENT,
            ],
            PARTNERSHIP: [
                DocumentType.SERVICE_AGREEMENT_DOCUMENT,
                DocumentType.SELFIE_WITH_PRIMARY_ID_DOCUMENT,
                DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT,
                DocumentType.SEC_CERTIFICATE_REGISTRATION_DOCUMENT,
                DocumentType.ARTICLES_OF_PARTNERSHIP_DOCUMENT,
                DocumentType.NOTARIZED_PARTNER_CERTIFICATE_DOCUMENT,
                DocumentType.BIR_2303_DOCUMENT,
            ],
            CORPORATION: [
                DocumentType.SERVICE_AGREEMENT_DOCUMENT,
                DocumentType.SELFIE_WITH_PRIMARY_ID_DOCUMENT,
                DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT,
                DocumentType.SEC_CERTIFICATE_REGISTRATION_DOCUMENT,
                DocumentType.ARTICLES_OF_INCORPORATION_DOCUMENT,
                DocumentType.NOTARIZED_SECRETARY_CERTIFICATE_DOCUMENT,
                DocumentType.LATEST_GIS_DOCUMENT,
                DocumentType.BIR_2303_DOCUMENT,
            ],
            FOREIGN_NONSEC: [
                DocumentType.SERVICE_AGREEMENT_DOCUMENT,
                DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT,
                DocumentType.AUTHORIZED_PERSON_PASSPORT_DOCUMENT,
                DocumentType.PROOF_OF_COMPANY_REGISTRATION_DOCUMENT,
                DocumentType.COUNTRY_ISSUED_BUSINESS_LICENSE_DOCUMENT,
                DocumentType.ARTICLES_OF_INCORPORATION_DOCUMENT,
                DocumentType.BANK_BOOK_SCAN_DOCUMENT,
            ],
        };
        const primaryAndSecondaryIds = [...Object.values(PrimaryIDs), ...Object.values(SecondaryIDs)];
        return this.kycDocuments.filter((document) => {
            return (requiredDocumentTypes[businessType].includes(document.documentType) ||
                primaryAndSecondaryIds.includes(document.documentType));
        });
    }
    confirmed() {
        this.$emit('confirm');
    }
    onCancel() {
        this.confirmation = '';
        this.$emit('cancel');
        this.confirmErrors = [];
    }
};
__decorate([
    Getter('toggleConfirmation')
], ToggleConfirmationDialog.prototype, "toggleConfirmation", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ToggleConfirmationDialog.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ToggleConfirmationDialog.prototype, "requestOnProcess", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ToggleConfirmationDialog.prototype, "form", void 0);
__decorate([
    Prop({ type: Array, required: true })
], ToggleConfirmationDialog.prototype, "kycDocuments", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ToggleConfirmationDialog.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: 'Confirmation' })
], ToggleConfirmationDialog.prototype, "header", void 0);
__decorate([
    Prop({ type: String, default: "To Confirm this change, kindly type in 'CONFIRM' in the field" })
], ToggleConfirmationDialog.prototype, "message", void 0);
__decorate([
    Prop({ type: String, default: 'OK' })
], ToggleConfirmationDialog.prototype, "confirmLabel", void 0);
__decorate([
    Prop({ type: String, default: '400' })
], ToggleConfirmationDialog.prototype, "width", void 0);
__decorate([
    Prop({ type: String, default: '315' })
], ToggleConfirmationDialog.prototype, "height", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ToggleConfirmationDialog.prototype, "remove", void 0);
ToggleConfirmationDialog = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
            Modal,
        },
    })
], ToggleConfirmationDialog);
export default ToggleConfirmationDialog;
